import deviceTypes from './deviceTypes';
import screenSizes from './screenSizes';
import { IframeUtility } from '@inter-ikea-kompis/utilities';
import platform from './platform';
import { KIOSK } from '../constants';

function getOrientation() {
  return window.innerWidth > IframeUtility.calculateHeight(window.innerWidth)
    ? 'landscape'
    : 'portrait';
}

function getDeviceType(appWidth, orientation) {
  const deviceType = IframeUtility.getDeviceType();

  // The app should make no difference between tablet and desktop when in landscape
  if (deviceType === deviceTypes.TABLET && orientation === 'landscape') {
    return deviceTypes.DESKTOP;
  }

  // Overriding calculation from KOMPIS when changing browser size
  if (deviceType === deviceTypes.DESKTOP) {
    if (orientation === 'portrait') {
      if (appWidth <= screenSizes.xSmall) {
        return deviceTypes.MOBILE;
      } else if (appWidth <= screenSizes.medium) {
        return deviceTypes.TABLET;
      } else {
        return deviceTypes.DESKTOP;
      }
    }

    if (IframeUtility.calculateHeight(appWidth) <= screenSizes.xSmall) {
      return deviceTypes.MOBILE;
    } else {
      return deviceTypes.DESKTOP;
    }
  }

  return deviceType;
}

function getUserAgent() {
  const orientation = getOrientation();
  const deviceType = platform.isKiosk
    ? KIOSK
    : getDeviceType(window.innerWidth, orientation);

  return { orientation, deviceType };
}

function isMobile() {
  return getUserAgent().deviceType === deviceTypes.MOBILE;
}

export { getUserAgent, getDeviceType, isMobile };
